import { Button, DatePicker, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const SaveDeliveryUnsave = ({
  open,
  closeOriginalTab,
  close,
  setLoading,
  getDeliveryUnsaveList,
  getDeliverySaveList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleSaveToDelivery = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/save-delivery-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to receiving successfully.");
          setTimeout(() => {
            closeOriginalTab();
            close();
            setLoadings(false);
            setLoading(false);
            getDeliveryUnsaveList();
            getDeliverySaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Prepared Delivery Order"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleSaveToDelivery}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="po_number"
            label="PO Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set PO" size="large" />
          </Form.Item>

          <Form.Item
            name="dr_number"
            label="DR Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set DR Number" size="large" />
          </Form.Item>

          <Form.Item
            name="dr_from"
            label="DR From"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set Delivery From" size="large" />
          </Form.Item>

          <Form.Item
            name="dr_date"
            label="DR Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SaveDeliveryUnsave;
